import dayjs from 'dayjs'

interface DateShortcutButtonProps {
  label?: string
  onClick: (event: React.MouseEvent, date: Date) => void
}

const DateShortcutButton = ({
  label = 'Expires in one year',
  onClick,
}: DateShortcutButtonProps) => {
  const handleClick = (event: React.MouseEvent) => {
    const date = dayjs().add(1, 'year').toDate()
    onClick(event, date)
  }

  return (
    <button
      type="button"
      className="mt-1 self-start text-xs text-doubleNickel-brand-500 hover:underline"
      onClick={handleClick}
    >
      {label}
    </button>
  )
}

export default DateShortcutButton
